import { WrapLgMarginBottom } from 'App/global-style';
import styled from 'styled-components';

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > * {
    margin-top: 32px;
  }

  > *:first-child {
    margin-top: 0px;
  }
`;

export const AlertContainer = styled(WrapLgMarginBottom)`
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap-reverse;
  gap: 24px;
  margin: 24px;
  max-width: 496px;
`;

export const TextContainer = styled.div`
  flex-basis: 306px;
  flex-grow: 1;
`;

export const IllustrationContainer = styled.div`
  display: flex;
`;

export const Title = styled.strong`
  display: block;
  line-height: 24px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
`;
